function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_2188",
  "data-name": "Path 2188",
  d: "M39.709-3.31l-1.9-.105,2.355-8.247.63-3.122H36.176a21.451,21.451,0,0,1-3.067-.435L30.569-11.79h-2.2l.965-4.188c-1-.212-1.688-.368-1.688-.368l-.428-.095v-.438c0-.426,0-.457,2.117-.9l-.965-4.19h2.2l2.539,3.427a21.529,21.529,0,0,1,3.067-.433h4.616l-.639-3.166-2.345-8.2,1.9-.105L48.6-18.976h7.66c2.123,0,3.437,1.088,3.437,2.1s-1.314,2.1-3.437,2.1H48.6Zm-7.07-13.114.338.064a22.355,22.355,0,0,0,3.2.479h5.956l-.9,4.476L39.265-4.528l8.8-11.354h8.2c1.636,0,2.341-.761,2.341-1s-.7-1-2.341-1h-8.2l-8.8-11.351L41.217-22.4l.915,4.52H36.177a22.249,22.249,0,0,0-3.2.478l-.338.064-2.621-3.537h-.275l.908,3.937-.286.059.286.059-.908,3.936h.275Z",
  transform: "translate(-27.214 30.45)",
  fill: "#ec411b"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Group_1349",
  "data-name": "Group 1349",
  transform: "translate(139.5)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_1195",
  "data-name": "Group 1195",
  transform: "translate(-4.5 0)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_1190",
  "data-name": "Group 1190",
  clipPath: "url(#clip-path)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_2187",
  "data-name": "Path 2187",
  d: "M22.214-35.45H63.825V.821H22.214Z",
  transform: "translate(-26.78 30.884)",
  fill: "#ec411b"
}))), /*#__PURE__*/React.createElement("line", {
  id: "Line_20",
  "data-name": "Line 20",
  x2: 132,
  transform: "translate(-138.5 13.89)",
  fill: "none",
  stroke: "#ec411b",
  strokeLinecap: "round",
  strokeWidth: 2,
  strokeDasharray: 10
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_34",
  "data-name": "Line 34",
  x2: 132,
  transform: "translate(36.5 13.89)",
  fill: "none",
  stroke: "#ec411b",
  strokeLinecap: "round",
  strokeWidth: 2,
  strokeDasharray: 10
}));

function SvgJourneyLine2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 309,
    height: 27.14,
    viewBox: "0 0 309 27.14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJourneyLine2);
export default __webpack_public_path__ + "static/media/journeyLine2.ed8fb736.svg";
export { ForwardRef as ReactComponent };